import React from "react"
import "./SuccessAnimation.scss"

export const SuccessAnimation = ({style}: {style?: React.CSSProperties}) => {
  return (
    <div className="success-checkmark" style={style}>
        <div className="check-icon">
        <span className="icon-line line-tip"></span>
        <span className="icon-line line-long"></span>
        <div className="icon-circle"></div>
        <div className="icon-fix"></div>
        </div>
    </div>
  )
}